import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=bfb07b7e&scoped=true&"
import script from "./SortItem.vue?vue&type=script&lang=js&"
export * from "./SortItem.vue?vue&type=script&lang=js&"
import style0 from "./SortItem.vue?vue&type=style&index=0&id=bfb07b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb07b7e",
  null
  
)

export default component.exports